<template>
  <div>
    <!-- 收货明细 -->
    <div class="reverse-row font-weight-700">收货明细</div>
    <el-table :data="receiveDetailList" style="width: 100%" :header-cell-style="{
        background: '#E8E8E8'
      }" border>
      <el-table-column prop="rowNumber" label="行项目号" align="center" />
      <el-table-column prop="itemCode" label="物料编码" align="center" />
      <el-table-column prop="itemName" label="物料名称" align="center" />
      <el-table-column prop="itemAmount" label="总金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.itemAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="已收货金额(元)" align="center">
        <template slot-scope="scope">
          {{ formatPrice(scope.row.receiveAmount - scope.row.reverseAmount) }}
        </template>
      </el-table-column>
      <el-table-column label="最后一次收货" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.isLast === 1">是</span>
          <span v-if="scope.row.isLast === 0">否</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 冲销记录 -->
    <div class="reverse-row font-weight-700">
      冲销记录
      <div class="operate_btn operate_btn_white" @click="dialogVisible = true" v-if="canSubmitReverse">+新建冲销</div>
    </div>
    <el-table :data="tableRowData" style="width: 100%" :header-cell-style="{
        background: '#E8E8E8'
      }" :span-method="mergeRowMethod" border>

      <el-table-column prop="requestTime" label="冲销时间" align="center" >
        <template slot-scope="scope">
            {{ scope.row.requestTime | parseTime('{y}-{m}-{d} {h}:{i}:{s}') }}
          </template>
      </el-table-column>
      <el-table-column prop="rowNumber" label="行项目号" align="center" />
      <el-table-column prop="itemCode" label="物料编码" align="center" />
      <el-table-column prop="itemName" label="物料名称" align="center" />
      <el-table-column prop="reverseAmount" label="冲销金额(元)" align="center" >
        <template slot-scope="scope">
            {{ formatPrice(scope.row.reverseAmount) }}
          </template>
      </el-table-column>
    </el-table>

    <!-- 新建冲销 -->
    <el-dialog title="新建冲销" :visible.sync="dialogVisible" :close-on-click-modal="false" top="10vh"
      v-loading="dialogLoading">
      <el-table :data="receiveDetailList" style="width: 100%" :header-cell-style="{
          background: '#E8E8E8'
        }">
        <el-table-column prop="rowNumber" label="行项目号" align="center" />
        <el-table-column prop="itemCode" label="物料编码" align="center" />
        <el-table-column prop="itemName" label="物料名称" align="center" />
        <el-table-column prop="itemAmount" label="总金额(元)" align="center">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.itemAmount) }}
          </template>
        </el-table-column>
        <el-table-column label="可冲销金额(元)" align="center">
          <template slot-scope="scope">
            {{ formatPrice(scope.row.receiveAmount - scope.row.reverseAmount) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="冲销金额" width="200px">
          <template slot-scope="scope">
            <el-input v-model="scope.row.submitReverseAmount"
              :disabled="(scope.row.receiveAmount - scope.row.reverseAmount) === 0" placeholder="请输入金额" type="number" :min="0" :max="scope.row.receiveAmount - scope.row.reverseAmount"
              @input="val => handleInput(val, scope.$index, scope.row.receiveAmount - scope.row.reverseAmount)">
              <template slot="append">元</template>
            </el-input>
          </template>
        </el-table-column>
      </el-table>

      <div slot="footer" class="operation_btn_box photo-bottom">  
        <div class="operate_btn operate_btn_white" @click="dialogVisible = false">取消</div>
        <DialogPop 
        :marLeft="true" 
        isType="0" 
        btnText="确定" 
        centerText="是否确认新建冲销？" 
        appendToBody 
        @confirm="submitReverse"></DialogPop>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import gameplanApi from "@/api/gameplan"
import DialogPop from "./dialog-pop.vue"
import { create, all } from 'mathjs'
const math = create(all, {})
export default {
  name: 'ApprovalDetailPassed',
  components: {
    DialogPop
  },
  props: {
    receiveDetailList: {
      type: Array,
      default: () => {
        return []
      }
    },
    detailList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 冲销记录
    reverseList: {
      type: Array,
      default: () => {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dialogVisible: false,
      dialogLoading: false,
      tableRowData: [],
    }
  },
  computed: {
    // 能否新建冲销
    canSubmitReverse(){
      return this.detailList.requestStatus === 500
    }
  },
  watch: {
    reverseList(val) {
      this.loadRowData(val)
    }
  },
  methods: {
    // 提交新建冲销
    async submitReverse() {
      if (this.dialogLoading) return
      const payload = {
        receiveId: this.detailList.receiveId,
        reverseDetailList: (() => {
          const ableReverseList = this.receiveDetailList.filter(item => {
            return item.submitReverseAmount && item.submitReverseAmount != 0
          })
          return ableReverseList.map(item => {
            return {
              rowNumber: item.rowNumber,
              reverseAmount: item.submitReverseAmount || 0,
            }
          })
        })()
      }
      const ableReverseAmount = this.receiveDetailList.reduce((pre, item) => {
        return pre + item.submitReverseAmount || 0
      }, 0)
      this.dialogLoading = true
      const { data } = await gameplanApi.submitReverse(payload)
      if (data.resultCode === '0') {
        this.dialogVisible = false
        this.$message.success('冲销记录提交成功')
        this.$emit('on-submitReverse')
      } else {
        this.$message.error(data.resultMsg)
      }
      this.dialogLoading = false
    },
    handleInput(val, index, num) {
      // console.log(val, index, num)
      if (val >= 0) {
        if (math.number(math.subtract(math.bignumber(val || 0), num)) > 0) {
          this.receiveDetailList[index].submitReverseAmount = num
        }
      } else {
        this.receiveDetailList[index].submitReverseAmount = 0
      }
    },
    // 金额千分
    formatPrice(price) {
      return String(price).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    loadRowData(originArr) {
      this.tableRowData = []
      if (Array.isArray(originArr)) {
        originArr.map(items => {
          if (Array.isArray(items.reverseDetailList)) {
            items.reverseDetailList.map((item, index) => {
              let content = {}
              content = item
              content['requestTime'] = items.requestTime
              if (index === 0) {
                content['rowNum'] = items.reverseDetailList.length
              }
              this.tableRowData.push(content)
            })
          }
        })
      }
    },
    mergeRowMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        return {
          rowspan: row.rowNum, // 合并行数
          colspan: row.rowNum > 0 ? 1 : 0  // 合并列数
        };

      }
    },
  },
}
</script>
<style lang='scss' scoped>
.operation_btn_box {
  width: 100%;
  display: flex;
  justify-content: center;
  // margin: -30px 0 10px 0;

}

.operate_btn {
  display: inline-block;
  text-align: center;
  padding: 0px 20px;
  border-radius: 4px;
  margin: 0px 10px 0 10px;
  cursor: pointer;
}

.operate_btn_red {
  color: white;
  background-color: rgb(214, 0, 0);
}

.operate_btn_white {
  color: rgb(214, 0, 0);
  background-color: white;
  border: 1px solid rgb(214, 0, 0);
}


.reverse-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  line-height: 24px;
  margin-bottom: 3px;
  padding: 10px;
}

::v-deep .el-dialog {
  margin: 0 auto 15px;
}

::v-deep .el-dialog__body {
  overflow: auto;
  max-height: 70vh;
}

::v-deep .el-dialog__footer {
  padding: 10px !important;
}

.photo-bottom {
  // margin-top: 100px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
}
</style>